import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DOCUMENT } from '@angular/common';

@Component({
  selector: 'app-new-functionality',
  templateUrl: './new-functionality.component.html',
  styleUrls: ['./new-functionality.component.scss'],
})
export class NewFunctionalityComponent implements OnInit {

  targetRect!: DOMRect;
  isNotSuperAdmin: boolean = true;

  constructor(
    @Inject(DOCUMENT) private document: Document, public dialogRef: MatDialogRef<NewFunctionalityComponent>, @Inject(MAT_DIALOG_DATA) public data: any,) {}

  ngOnInit() {
    const target = this.document.querySelector('#nav-biuwer');
    if (target) {
      this.targetRect = target.getBoundingClientRect();
    }
  }
}